// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const getBuildVariant = () => window.BUILD_VARIANT;
